/* RESPONSIBLE TEAM: team-proactive-support */
export default function (index) {
  if (index < 0) {
    return 'A';
  }
  let i = index % 26;
  let asciiA = 'A'.charCodeAt(0);
  return String.fromCharCode(i + asciiA);
}
